import { render, staticRenderFns } from "./o-eventbrite-widget.vue?vue&type=template&id=137b01cf&scoped=true"
import script from "./o-eventbrite-widget.vue?vue&type=script&lang=js"
export * from "./o-eventbrite-widget.vue?vue&type=script&lang=js"
import style0 from "./o-eventbrite-widget.vue?vue&type=style&index=0&id=137b01cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137b01cf",
  null
  
)

export default component.exports